export default __webpack_public_path__ + "static/media/badge_domain.bf4b1603.svg";